import { fetchJsonSchema, fetchAutomationList, deleteAutomation, addAutomation, editAutomation, type, getDartDetails, getAutomationListCnt, fetchExportData } from './automation_common_func';

type AutohealProps = {
  dartNo: number;
  automationSearchVal: any;
  rowID: number;
  newData: any;
  saveBtnClicked: boolean;
  jsonSchema: any;
  setSaveBtnClicked: any;
  setOverlayOpen: any;
  data: any;
  func: any;
  searchVal: string;
  pageNo: number;
  setTotalPages: any;
  setTotalRecords: any;
  isFilter?: boolean;
  dropDownValue1?: any;
  setIsFilter?: any
  dropdownValue2?: any
  setDartSpecs: any;
  setJsonData: any;
  setUiData: any;
  deleteAutomation: any;
  setDeleteAutomation: any;
  setDeleteDisabled: any;
  isRefresh?: boolean;
  setIsRefresh?: any;
  setRefreshToast?: any;
  filterArray?: string[];
  overlayName: string;
  setErrorToast: any;
  setToastMessage: any;
  setIsToast: any;
  setFormData?: any;
  setExportDetails: any;
  formData: any;
  selectedRowIdInTable: any;
  automationName: string;
  tenant: string;
  dartSpecs: string[];
  exportBtnClicked: boolean,
  setExportBtnClicked: any,
  setLoading: any;
  setSpinnerLoad?: any;
}

const autohealConfiguration = (props: AutohealProps) => {
  const dartNo = props.dartNo;
  var dartid = dartNo;

  const getAutoHealList = async (whereCondition: any, limit: any = null, offset: any = null) => {
    try {
      const { data, status } = await fetchAutomationList(whereCondition, limit, offset);

      if (status === 'success' && data.length > 0) {
        if (props.overlayName === 'editAutomation') {
          props.setFormData({
            ...props.formData,
            name: data[0]?.automationName,
            description: data[0]?.description,
            jsonData: JSON.parse(data[0]?.jsonValue)
          });
          props.setSpinnerLoad(false);
        } else {
          props.setLoading(true);
          props.func(data);
        }
      } else {
        props.func(data);
      }
    } catch (error) {
      console.log("getAutoHealList error=", error);
      props.func([]);
    }
  };

  const getExportData = async (condition: object) => {
    const { data, status } = await fetchExportData(condition);

    if (status === 'success') {
      props.setExportDetails && props.setExportDetails(data);
    }
    props.setExportBtnClicked(false);
  }

  const deleteUnattachedAutomation = async (ids: number[]) => {
    try {
      const { data, status } = await deleteAutomation(ids, 'autoheal', props.tenant);

      if (status === 'success' && data.affected_rows > 0) {
        props.setDeleteDisabled(true);
        props.setDeleteAutomation(false);
        props.setIsToast(true);

        getAutoHealList({ dartid: dartid, types: 'autoheal' }, 50, props.pageNo);
      } else {
        props.setToastMessage(`Autoheal ${props.selectedRowIdInTable.length < 2 ? 'Automation' : 'Automations'} deletion failed`);
        props.setErrorToast(true);
      }
    } catch (error) {
      props.setToastMessage(`Autoheal ${props.selectedRowIdInTable.length < 2 ? 'Automation' : 'Automations'} deletion failed`);
      props.setErrorToast(true);
    }
  }

  const getJsonSchema = async (dartid: number) => {
    try {
      const { data, status } = await fetchJsonSchema(dartid);

      if (status === 'success' && data.length > 0) {
        const uiSchema = JSON.parse(data[0]?.uiSchema);
        const jsonSchemaData = JSON.parse(data[0]?.jsonSchema);

        uiSchema["ui:submitButtonOptions"] = { "norender": true };

        data[0]?.jsonSchema != undefined && props.setJsonData(jsonSchemaData);
        data[0]?.uiSchema != undefined && props.setUiData(uiSchema);
      } else {
        props.setJsonData({});
        props.setUiData({});
      }
    } catch (error) {
      console.log("getJsonSchema error=", error);
      props.setJsonData({});
      props.setUiData({});
    }
  };

  const createAutomation = async (automationName: string, description: string, jsonVal: string, dartid: number, types: string, tenant: string) => {
    try {
      const { status } = await addAutomation(automationName, description, jsonVal, dartid, types, tenant);

      if (status === 'success') {
        props.setIsToast(true);
        props.setOverlayOpen(false);
        setTimeout(() => {
          props.setSaveBtnClicked(false);
        }, 1000);

        getAutoHealList({ dartid: dartid, types: 'autoheal' }, 50, props.pageNo);
      } else {
        props.setToastMessage(`${automationName} automation creation failed`);
        props.setErrorToast(true);
      }
    } catch (error) {
      console.log("createAutomation error=", error);
      props.setToastMessage(`${automationName} automation creation failed`);
      props.setErrorToast(true);
    }
  }

  const modifyAutomation = async (automationName: string, description: string, jsonVal: string, dartid: number, id: number, tenant: string) => {
    try {
      const { status } = await editAutomation(automationName, description, jsonVal, dartid, id, tenant, 'autoheal');

      if (status === 'success') {
        props.setOverlayOpen(false);
        props.setIsToast(true);
        setTimeout(() => {
          props.setSaveBtnClicked(false);
        }, 1000);

        getAutoHealList({ dartid: dartNo, types: 'autoheal' }, 50, props.pageNo);
      } else if (status === 'failed') {
        props.setToastMessage("This automation can't be edited as it is already configured");
        props.setErrorToast(true);
        props.setOverlayOpen(false);
        setTimeout(() => {
          props.setSaveBtnClicked(false);
        }, 1000);
      } else {
        props.setToastMessage(`Error occured while saving ${automationName} automation`);
        props.setErrorToast(true);
        props.setOverlayOpen(false);
        setTimeout(() => {
          props.setSaveBtnClicked(false);
        }, 1000);
      }
    } catch (error) {
      console.log("modifyAutomation error=", error);

      props.setToastMessage(`Error occured while saving ${automationName} automation`);
      props.setErrorToast(true);
      props.setOverlayOpen(false);
      setTimeout(() => {
        props.setSaveBtnClicked(false);
      }, 1000);
    }
  }

  const automationSearch = async (whereCondition: any, limit: any, offset: any) => {
    try {
      const { data, status } = await fetchAutomationList(whereCondition, limit, offset);

      if (status === 'success' && data) {
        let jsonVal = props.jsonSchema;

        data.forEach((val: any) => {
          !(jsonVal.properties?.AutomationExecute?.examples.includes(val.automationName)) && jsonVal.properties?.AutomationExecute?.examples.push(val.automationName);
        });
      }
    } catch (error) {
      console.log("automationSearch error=", error);

    }
  }

  if (props.dartSpecs.length === 0) {
    getJsonSchema(dartNo);
    getDartDetails(dartNo, props.setDartSpecs);
  } else if (props.isRefresh) {
    props.setIsRefresh(false);
    props.setRefreshToast(true);
    setTimeout(() => {
      props.setRefreshToast(false);
    }, 3000);
  }

  if (props.searchVal?.length > 0 && props.searchVal !== '' && props.overlayName === '') {
    getAutoHealList({ function: 'search', "types": "autoheal", dartid: dartid, search: props.searchVal }, 50, props.pageNo);
    getAutomationListCnt({ function: 'search', "types": "autoheal", dartid: dartid, search: props.searchVal }, props.setTotalRecords, props.setTotalPages);
  } else if (props.isFilter === true) {
    const condition = { filter: props.filterArray, function: 'filter', "types": "autoheal" };

    getAutoHealList(condition, 50, props.pageNo);
    getAutomationListCnt(condition, props.setTotalRecords, props.setTotalPages);
  } else if (props.deleteAutomation && props.selectedRowIdInTable.length > 0) {
    deleteUnattachedAutomation(props.selectedRowIdInTable);
  } else if (props.saveBtnClicked && props.newData !== undefined && Object.keys(props.newData).length > 0) {
    props.overlayName === 'addAutomation' && createAutomation(props.newData.name, props.newData.description, props.newData.jsonData, dartNo, 'autoheal', props.tenant);

    props.overlayName === 'editAutomation' && modifyAutomation(props.newData.name, props.newData.description, props.newData.jsonData, dartNo, props.rowID, props.tenant);
  } else if (!(props.saveBtnClicked) && props.overlayName === 'editAutomation' && props.automationSearchVal?.length < 1) {
    getAutoHealList({ types: 'autoheal', dartid: dartNo, id: props.rowID }, 0, null);
  } else if (props.automationSearchVal?.length > 0 && props.automationSearchVal !== '') {
    automationSearch({ types: 'automation', automationName: { contains: props.automationSearchVal } }, null, null);
  } else if (props.exportBtnClicked) {
    getExportData({ types: "autoheal", function: 'export', tenant: props.tenant });
  } else {
    props.overlayName !== 'addAutomation' && getAutoHealList({ dartid: dartid, types: 'autoheal' }, 50, props.pageNo);

    props.overlayName !== 'editAutomation' && getAutomationListCnt({ dartid: dartid, types: 'autoheal' }, props.setTotalRecords, props.setTotalPages);
  }
}

export { autohealConfiguration }
